import React from 'react';
import { Droplet, Shield, CheckCircle } from 'lucide-react';

const Benefits = () => {
  const benefits = [
    {
      icon: Droplet,
      title: 'Evite infiltrações desde a fundação',
      description: 'Técnicas preventivas que protegem sua obra desde o início'
    },
    {
      icon: Shield,
      title: 'Reduza retrabalhos e custos',
      description: 'Economize tempo e dinheiro aplicando o método correto'
    },
    {
      icon: CheckCircle,
      title: 'Checklist prático para executores e engenheiros',
      description: 'Material de apoio para aplicação imediata na sua obra'
    }
  ];

  return (
    <section className="benefits-section">
      <div className="benefits-container">
        <h2 className="benefits-title">O que você vai aprender</h2>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div key={index} className="benefit-card">
                <div className="benefit-icon-wrapper">
                  <Icon className="benefit-icon" />
                </div>
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;